module.exports = __webpack_public_path__ + "static/media/instagram_icon.f7482cea.svg";